import teaserControl from "../../blog/js/teaserControl";
import $ from 'jquery'
import '../../website/js/simpleScroller'
import '../../website/js/jquery.scrollTo.min'

document.addEventListener('DOMContentLoaded', async () => {
    if (document.querySelector('.startseite')) {

        $('.startseite .news-scroller > ul').simpleScroller({ counter: true })

        teaserControl({url: '/news'});
    }
})